import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import {
    DossierArticleProvider,
    DossierGroupModal,
    DossierRoutingProvider,
    dossiersBasePath,
    DossierStepProvider,
    DossierUrgentModal,
    ExportDossierModal,
    OfferProvider,
    useLazyDataLoader,
} from '@europrocurement/l2d-modules';
import { dossierValidationPath, addFormalityPath } from '../constants';
import { ordersBasePath } from '../../Orders';
import AssignDossierModal from './liste/ActionMenu/AssignDossierModal.tsx/AssignDossierModal';

export const DossierRoot: React.FunctionComponent = function () {
    const { loadValidators } = useLazyDataLoader();

    useEffect(() => {
        loadValidators();
    }, [loadValidators]);

    return (
        <OfferProvider>
            <DossierStepProvider>
                <DossierRoutingProvider
                    orderBasePath={ordersBasePath}
                    dossierBasePath={dossiersBasePath}
                    dossierValidationPath={dossierValidationPath}
                    addFormalityPath={addFormalityPath}
                >
                    <DossierArticleProvider>
                        <Outlet />
                    </DossierArticleProvider>
                </DossierRoutingProvider>

                <DossierGroupModal />
                <ExportDossierModal />
                <DossierUrgentModal />
                <AssignDossierModal />
            </DossierStepProvider>
        </OfferProvider>
    );
};
